import RestClient from "@/api/utils/baseRestClient";
import atmoClient from "@/setup/clients/atmoClient";

export const adminInformationRestClient = new RestClient(
  atmoClient,
  "admininformations"
);
